export const LIBRARY_TYPE = {
    PERSONAL: 'personal',
    ORG: 'org',
} as const;

export type LibraryType = typeof LIBRARY_TYPE[keyof typeof LIBRARY_TYPE];

export const DEFAULT_LIBRARY_TYPE: LibraryType = LIBRARY_TYPE.PERSONAL;

export const LIBRARY_TYPE_STORAGE_KEY = 'LibraryType';

export const isLibraryType = (value: unknown): value is LibraryType =>
    value === LIBRARY_TYPE.PERSONAL || value === LIBRARY_TYPE.ORG;

/**
 * Returns the first valid library type from the given candidates.
 * Invalid values such as `undefined`, `"undefined"`, or empty strings are skipped.
 */
export const resolveLibraryType = (...candidates: unknown[]): LibraryType => {
    for (const candidate of candidates) {
        if (isLibraryType(candidate)) {
            return candidate;
        }
    }
    return DEFAULT_LIBRARY_TYPE;
};

export const persistLibraryType = (...candidates: unknown[]): LibraryType => {
    const libraryType = resolveLibraryType(...candidates);
    localStorage.setItem(LIBRARY_TYPE_STORAGE_KEY, libraryType);
    return libraryType;
};

/**
 * On page reload, keep a valid in-session library choice from localStorage.
 * Use the Settings default only when nothing valid is stored yet.
 */
export const hydrateSessionLibraryType = (userLibraryDefault: unknown): LibraryType =>
    persistLibraryType(localStorage.getItem(LIBRARY_TYPE_STORAGE_KEY), userLibraryDefault);

